import { LoadedUser } from '../../interfaces';
import { isUserAdminOrManager } from '../../utils/global/helper';

export function hasAdsAccess(
  user: LoadedUser | null | undefined,
  canAccessAds: boolean,
): boolean {
  const isIndependent = user?.business?.type === 'INDEPENDENT';
  return (
    !!user &&
    canAccessAds &&
    !!user.business?.hasAdsFeature &&
    (isIndependent || (isUserAdminOrManager(user) && !!user.canManageCampaigns))
  );
}
